import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
} from '@mui/material'
import React from 'react'
import styles from './confirmDialogStyle'

const ConfirmDialog = (props: any) => {
  const { confirmDialog, setConfirmDialog } = props

  return (
    <Dialog open={confirmDialog.isOpen}>
      <Paper elevation={3} sx={styles.customCancelBookingContainer}>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Box component={'p'} sx={styles.customCancelBookingHeader}>
            {confirmDialog.title}
          </Box>
          <Box component={'p'} sx={styles.customCancelBookingMessage}>
            {confirmDialog.subtitle}
          </Box>
        </DialogContent>
        <DialogActions style={{ textAlign: 'right' }}>
          <Button
            onClick={() =>
              setConfirmDialog({ ...confirmDialog, isOpen: false })
            }
            sx={styles.customCancelBookingCancelButton}
            variant="outlined"
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={confirmDialog.onConfirm}
            sx={styles.customCancelBookingConfirmButton}
            variant="contained"
            color="secondary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  )
}

export default ConfirmDialog
